import displaySuggestionsComponent from './components/display.suggestions.component';
import displaySuggestionsUpgradeComponent from './components/display.suggestions.upgrade.component';
import upgradeEventComponent from './components/upgrade.event.component';
import upgradeOptionComponent from './components/upgrade.option.component';

import displaySuggestionsController from './controllers/display.suggestions.controller';
import displaySuggestionsUpgradeController from './controllers/display.suggestions.upgrade.controller';
import upgradeEventController from './controllers/upgrade.event.controller';

let sharedCheckoutModule = angular.module('spabooker.shared.checkout', ['spabooker.basket', 'spabooker.shared.availability'])
    .component('displaySuggestions', displaySuggestionsComponent)
    .component('displaySuggestionsUpgrade', displaySuggestionsUpgradeComponent)
    .component('upgradeEvent', upgradeEventComponent)
    .component('upgradeOption', upgradeOptionComponent)

    .controller('displaySuggestionsController', displaySuggestionsController)
    .controller('displaySuggestionsUpgradeController', displaySuggestionsUpgradeController)
    .controller('upgradeEventController', upgradeEventController)
    ;

export default sharedCheckoutModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/checkout/index.js